import { looksLikeHtml, markdownToHtml, sanitizeHtml } from "@/lib/noteFormat";

/**
 * NoteBody — read-only renderer for a saved note. Handles BOTH:
 *   • new WYSIWYG notes stored as HTML (contentEditable output)
 *   • legacy notes stored as markdown ("**bold**", "*italic*", "- list")
 *
 * Everything passes through sanitizeHtml() so we only ever render our
 * allow-listed tags (strong/b/em/i/u/br/p/div/ul/ol/li). Rendered via
 * dangerouslySetInnerHTML on top of the sanitiser output — attribute
 * stripping + tag allow-list closes the normal XSS vectors.
 */
export default function NoteBody({ text, className = "", testId }) {
  const raw = text || "";
  const html = sanitizeHtml(looksLikeHtml(raw) ? raw : markdownToHtml(raw));
  return (
    <div
      className={`note-body ${className}`}
      data-testid={testId}
      // eslint-disable-next-line react/no-danger -- content is sanitised above
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
